export default __webpack_public_path__ + "static/media/b4.a7b2331b.svg";